import React, { useRef } from "react";
import { modalActions } from "../../../context/actions/modalActions";
import useStore from "../../../context/useStore";
import useModalA11y from "./useModalA11y";
import "./custom-modal.scss";

const CustomModal = () => {
  const [state, dispatch] = useStore();
  const actions = modalActions(state, dispatch);
  const modalProps = state.modal;
  const cardRef = useRef(null);
  // Quand la modale 2 est empilée au-dessus, elle prend la main sur
  // Escape / focus trap — on désactive les écouteurs de celle-ci.
  const modal2Open = state.modal2 && state.modal2.isOpen;

  const close = () => actions.updateModal({ isOpen: false, content: null });

  useModalA11y({
    isOpen: !!modalProps.isOpen,
    enabled: !modal2Open,
    canClose: !modalProps.noClose,
    onClose: close,
    cardRef,
  });

  return (
    <div
      className="custom-modal-overlay"
      style={{
        display: modalProps.isOpen ? "flex" : "none",
        zIndex: "9999",
        ...modalProps.style,
      }}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget && !modalProps.noClose) close();
      }}
    >
      <div
        className="custom-modal-card"
        role="dialog"
        aria-modal="true"
        tabIndex={-1}
        ref={cardRef}
      >
        <div className="custom-modal-body">{modalProps.content}</div>
        <div className="custom-modal-footer">
          {modalProps.actions}
          {!modalProps.noClose && (
            <button onClick={close} className="btn btn-default">
              Fermer
              <i className="fa fa-times ml-2" aria-hidden="true" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
